// Blocks a disabled portal module route for portal users. Internal users
// (director/administrator/consultant) always pass through.
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useView } from "@/context/ViewContext";
import { enabledPortalRouteSet } from "@/lib/portalModules";

const INTERNAL = new Set(["director", "administrator", "consultant"]);

export default function ModuleGuard({ id, children }) {
    const { user } = useAuth();
    const { portalClient } = useView();

    const isInternal = !user || INTERNAL.has(user.role);
    let blocked = false;
    if (!isInternal) {
        if (id === "weekly-reports") {
            // Fail-open while portalClient is still loading (matches
            // enabledPortalRouteSet's null='show all' convention) so a direct
            // nav/refresh doesn't bounce the user out before data arrives.
            blocked = portalClient ? !portalClient.weekly_reports_enabled : false;
        } else {
            const enabled = enabledPortalRouteSet(portalClient);
            blocked = enabled !== null && !enabled.has(id);
        }
    }

    useEffect(() => {
        if (blocked) toast.error("This module is not enabled for your portal.");
    }, [blocked]);

    if (blocked) return <Navigate to="/app/dashboard" replace />;
    return children;
}
